import { render, staticRenderFns } from "./RouteDev.vue?vue&type=template&id=a840e3c0&scoped=true&"
import script from "./RouteDev.vue?vue&type=script&lang=js&"
export * from "./RouteDev.vue?vue&type=script&lang=js&"
import style0 from "./RouteDev.vue?vue&type=style&index=0&id=a840e3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a840e3c0",
  null
  
)

export default component.exports